"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * A good resource to figure out the code is at http://keycode.info/
 */
var SPACE_KEY = exports.SPACE_KEY = 32;
var TAB_KEY = exports.TAB_KEY = 9;
var SHIFT_KEY = exports.SHIFT_KEY = 16;
var ARROW_LEFT_KEY = exports.ARROW_LEFT_KEY = 37;
var ARROW_UP_KEY = exports.ARROW_UP_KEY = 38;
var ARROW_RIGHT_KEY = exports.ARROW_RIGHT_KEY = 39;
var ARROW_DOWN_KEY = exports.ARROW_DOWN_KEY = 40;
var ENTER_KEY = exports.ENTER_KEY = 13;
var ESC_KEY = exports.ESC_KEY = 27;
var HOME_KEY = exports.HOME_KEY = 36;
var END_KEY = exports.END_KEY = 35;